import { EntryInfo, entryHref, spaceName } from '../utils';
import css from './entry-list.module.scss';

export function EntryList({ entries }: { entries: EntryInfo[] }) {
    return (
        <div className={css.list}>
            {entries.map((entry, idx) => {
                const href = entryHref(entry);
                return (
                    <div key={entry.id}>
                        <div className={css.entry}>
                            {entry.title &&
                                (href ? (
                                    <a className={css.title} href={href} target="_blank" rel="noreferrer">
                                        {entry.title}
                                    </a>
                                ) : (
                                    <span className={css.title}>{entry.title}</span>
                                ))}
                            <div className={css.meta}>
                                {entry.contentType && <span className={css.type}>◈ {entry.contentType}</span>}
                                {entry.environment && <span className={css.badge}>◉ {entry.environment}</span>}
                                {entry.spaceId && (
                                    <span className={css.space} title={entry.spaceId}>
                                        ⊞ {spaceName(entry.spaceId)}
                                    </span>
                                )}
                            </div>
                        </div>
                        {idx < entries.length - 1 && <div className={css.divider} />}
                    </div>
                );
            })}
        </div>
    );
}
